import { NotificationSettings } from "../../features/cabinet"

export const NotificationSettingsPage = () => {
    return (
        <NotificationSettings />
    )
}
